export const COMPOSE_INPUT_MODE_PLAIN = 'plain';
export const COMPOSE_INPUT_MODE_MARKDOWN = 'markdown';

export const COMPOSE_INPUT_MODE_OPTIONS = [
  COMPOSE_INPUT_MODE_PLAIN,
  COMPOSE_INPUT_MODE_MARKDOWN,
] as const;

export type ComposeInputMode = (typeof COMPOSE_INPUT_MODE_OPTIONS)[number];

export type ComposeContentType = 'text/plain' | 'text/markdown';

export const isComposeInputMode = (value: string): value is ComposeInputMode =>
  COMPOSE_INPUT_MODE_OPTIONS.includes(value as ComposeInputMode);

export const composeInputModeFromContentType = (
  contentType?: string | null,
): ComposeInputMode => {
  switch (contentType) {
    case 'text/markdown':
      return COMPOSE_INPUT_MODE_MARKDOWN;
    case 'text/plain':
    default:
      return COMPOSE_INPUT_MODE_PLAIN;
  }
};

export const contentTypeFromComposeInputMode = (
  inputMode: ComposeInputMode,
): ComposeContentType | undefined => {
  switch (inputMode) {
    case COMPOSE_INPUT_MODE_MARKDOWN:
      return 'text/markdown';
    case COMPOSE_INPUT_MODE_PLAIN:
      return undefined;
  }
};
